import { Translate } from 'react-redux-i18n';
import Dashboard from 'endpoints/dashboard';

export default class ConfirmationModal extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  setClientUpdateValue = (value) => {
    const { onClose } = this.props;
    Dashboard.runDBRelease(value);
    onClose();
  };

  render() {
    const { onClose } = this.props;
    const content = <Translate value="home.confirmation_modal.body_message" />;
    const footer = (
      <div className="modal-footer">
        <a
          href="#"
          className="btn btn-secondary"
          onClick={() => this.setClientUpdateValue('NONE')}
        >
          <Translate value="home.confirmation_modal.ctas.not_required" />
        </a>
        <a
          href="#"
          className="btn btn-secondary"
          onClick={() => this.setClientUpdateValue('OPTIONAL')}
        >
          <Translate value="home.confirmation_modal.ctas.optional_update" />
        </a>
        <a
          href="#"
          className="btn btn-primary"
          onClick={() => this.setClientUpdateValue('MANDATORY')}
        >
          <Translate value="home.confirmation_modal.ctas.force_update" />
        </a>
      </div>
    );
    return (
      <div className="confirmation-modal">
        <div className="modal fade show d-block">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <Translate value="home.confirmation_modal.header_title" />
                </h5>
                <button type="button" className="close" onClick={onClose}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">{content}</div>
              {footer}
            </div>
          </div>
        </div>
        <div className="modal-backdrop show fade" />
      </div>
    );
  }
}
